import { render, staticRenderFns } from "./ChallengeBox.vue?vue&type=template&id=b963e874&scoped=true"
import script from "./ChallengeBox.vue?vue&type=script&lang=js"
export * from "./ChallengeBox.vue?vue&type=script&lang=js"
import style0 from "./ChallengeBox.vue?vue&type=style&index=0&id=b963e874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b963e874",
  null
  
)

export default component.exports